"use strict";
/** @jsx jsx */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const styled_react_1 = require("./styled-react");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Link = (props) => {
    const { color, hoverColor, disabled, children, location, to, showActiveIndicator, staticContext, className } = props, rest = __rest(props, ["color", "hoverColor", "disabled", "children", "location", "to", "showActiveIndicator", "staticContext", "className"]);
    let active = false;
    if (showActiveIndicator) {
        active = lodash_1.includes(location.pathname, to);
    }
    return (core_1.jsx(react_router_dom_1.Link, Object.assign({ className: carabiners_1.joinStr(styles_scss_1.default.link, className), to: to, css: styled_react_1.dynamicLinkStyle(color, hoverColor, disabled, active) }, rest),
        children,
        active && core_1.jsx("div", { className: styles_scss_1.default.selectionCircle })));
};
Link.defaultProps = {
    children: undefined,
    color: styles_scss_1.default.primary,
    hoverColor: styles_scss_1.default.primaryHover,
    disabled: false,
    showActiveIndicator: false
};
exports.default = react_router_1.withRouter(Link);
